export const LOW_USAGE_LEFT = 0.25;
export const EXTREME_LOW_USAGE_LEFT = 0.1;

export const MS_IN_DAY = 1000 * 60 * 60 * 24;